import React, { useState, useEffect, useCallback } from "react";
import { CircularProgress, Grid, Paper, Backdrop } from "@mui/material";
import ApiForm from "./apiForm";
import ConsolidatedInvoice from "./consolidatedInvoice";
import TwoFa from "./reject";
import OutputPlatform from "./output";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import EmailSetting from "./emailSetting";
import ButtonComponent from "components/button";
import ErrorAlert from "helper/errorAlert";
import { useApiClient } from "context/ApiClientContext";

export default function Setting() {
  const [sysconfigData, setSysconfigData] = useState({
    epicor_ApiKey: "",
    epicor_RestUrl: "",
    epicor_UserName: "",
    epicor_Password: "",
    syteline_SQLServer: "",
    syteline_SQLUser: "",
    syteline_SQLPass: "",
    minutes_interval: 0,
    days_interval: 7,
    months_interval: 0,
    mqhost: "",
    smtp_host: "",
    smtp_port: "",
    smtp_ssl: false,
    smtp_user: "",
    smtp_pass: "",
    smtp_subject: "",
    smtp_email: "",
    outputplatform: "",
    twoFA: "",
  });
  const [changesMade, setChangesMade] = useState(false); // Track changes
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const apiClient = useApiClient();
  const navigate = useNavigate();

  // Fetch data from sysconfig API
  const fetchSysconfigData = useCallback(async () => {
    try {
      const response = await axios.get(`${apiClient}/sysconfig/1`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      });
      setSysconfigData(response.data);
    } catch (error) {
      console.error("Error fetching sysconfig data:", error);
      ErrorAlert(error, navigate);
    }
  }, []);

  useEffect(() => {
    fetchSysconfigData();
  }, []);

  
  const updateConfig = async () => {
    const toastId = toast.loading("Saving data...", {
      position: "top-right",
    });

    if (!sysconfigData.outputplatform) {
      toast.update(toastId, {
        render: "Output platform must be selected.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      return;
    }
  
    if (!sysconfigData.outputplatform) {
      toast.update(toastId, {
        render: "Output platform must be selected.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      return;
    }
  
    try {
      setOpenBackdrop(true);
      await new Promise((resolve) => setTimeout(resolve, 3000));
  
      const updatedSysconfigData = { ...sysconfigData };
  
      Object.keys(updatedSysconfigData).forEach((key) => {
        if (updatedSysconfigData[key] === null) {
          updatedSysconfigData[key] = "";
        }
      });
  
      await axios.put(`${apiClient}/sysconfig/1`, updatedSysconfigData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      });
  
      toast.update(toastId, {
        render: "Successfully updated.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
  
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      toast.update(toastId, {
        render: error.message || "Error",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setOpenBackdrop(false);
    }
  };

  // const updateConfig = async () => {
  //   const toastId = toast.loading("Saving data...", {
  //     position: "top-right",
  //   });
  //   try {
  //     setOpenBackdrop(true);
  //     await new Promise((resolve) => setTimeout(resolve, 3000));

  //     const updatedSysconfigData = { ...sysconfigData };

  //     Object.keys(updatedSysconfigData).forEach((key) => {
  //       if (updatedSysconfigData[key] === null) {
  //         updatedSysconfigData[key] = "";
  //       }
  //     });

  //     await axios.put(`${apiClient}/sysconfig/1`, updatedSysconfigData, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         Accept: "application/json",
  //       },
  //     });

  //     toast.update(toastId, {
  //       render: "Successfully updated.",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });

  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 3000);
  //   } catch (error) {
  //     toast.update(toastId, {
  //       render: error || "Error",
  //       type: "error",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };

  return (
    <>
      <Grid
        container
        spacing={5}
        bgcolor=""
        mt={1}
        display="flex"
        justifyContent="center"
      >
        <Grid item xs={12} lg={8}>
          <div>
            <EmailSetting
              apiSetting={sysconfigData}
              updateApiSetting={(updatedData) => {
                setSysconfigData(updatedData);
                setChangesMade(true);
              }}
            />
          </div>
        </Grid>
        <Grid item xs={12} lg={8}>
          <div>
            <ApiForm
              apiSetting={sysconfigData}
              updateApiSetting={(updatedData) => {
                setSysconfigData(updatedData);
                setChangesMade(true);
              }}
            />
          </div>
        </Grid>
        <Grid item xs={12} lg={8}>
          <div>
            <Paper>
              <ConsolidatedInvoice
                apiSetting={sysconfigData}
                updateApiSetting={(updatedData) => {
                  setSysconfigData(updatedData);
                  setChangesMade(true);
                }}
              />
              <OutputPlatform
                apiSetting={sysconfigData}
                updateApiSetting={(updatedData) => {
                  setSysconfigData(updatedData);
                  setChangesMade(true);
                }}
              />

              <TwoFa 
              apiSetting={sysconfigData}
              updateApiSetting={(updatedData) => {
                setSysconfigData(updatedData);
                setChangesMade(true);
              }}
              />

            {/* <TwoFa 
              apiSetting={sysconfigData}
              updateApiSetting={fetchSysconfigData}
            /> */}
            </Paper>
          </div>
        </Grid>
        <Grid item xs={12} lg={8} display="flex" justifyContent="end">
          <ButtonComponent value="contained" text="Save" callback={updateConfig} />
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
